<template>
  <v-container fluid class="mt-12">
    <UserProfile></UserProfile>
    <v-row justify="center" align="center">
      <v-col cols="12" md="6">
        <base-material-card
          icon="mdi-account"
          color="primary"
          inline
          class="px-5 my-12 py-3"
        >
          <template v-slot:after-heading>
            <div
              v-if="user.language === 'es'"
              class="title text-no-wrap font-weight-bold"
            >
              Perfil de {{ `${user.firstName}` }}
            </div>
            <div
              v-if="user.language === 'en'"
              class="title text-no-wrap font-weight-bold"
            >
              {{ `${user.firstName}'s` }} Profile
            </div>
          </template>
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                color="primary"
                fixed
                bottom
                left
                v-on="on"
                @click="$router.push(`/`)"
              >
                <v-icon>mdi-puzzle</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("userProfile.buttons.gotoModules") }}</span>
          </v-tooltip>

          <v-card-text class="">
            <div class="d-flex justify-center">
              <avatar :user="user"></avatar>
            </div>
            <v-divider class="my-8"></v-divider>
            <v-text-field
              filled
              prepend-icon="mdi-account"
              v-model="user.firstName"
              :label="$t('user.firstName')"
            ></v-text-field>
            <v-text-field
              filled
              prepend-icon="mdi-account-outline"
              v-model="user.lastName"
              :label="$t('user.lastName')"
            ></v-text-field>
            <v-text-field
              filled
              prepend-icon="mdi-at"
              v-model="user.email"
              :label="$t('user.email')"
            ></v-text-field>
            <v-text-field
              filled
              prepend-icon="mdi-account"
              v-model="user.role"
              :label="$t('user.userLevel')"
            ></v-text-field>
            <v-text-field
              filled
              readonly=""
              prepend-icon="mdi-calendar"
              v-model="dateFixed"
              :label="$t('user.date')"
            ></v-text-field>

            <v-text-field
              filled
              v-if="!user.isMetax"
              readonly=""
              prepend-icon="mdi-office-building"
              v-model="user.plant"
              :label="$t('user.plant')"
            ></v-text-field>
            <v-select
              filled
              prepend-icon="mdi-translate"
              :label="$t('user.language')"
              :items="[
                { value: 'en', text: 'English' },
                { value: 'es', text: 'Español' },
                { value: 'de', text: 'Deutsch' }
              ]"
              v-model="user.language"
              item-text="text"
              item-value="value"
            ></v-select>
            <v-select
              filled
              prepend-icon="mdi-ruler"
              :label="$t('user.metric')"
              :items="[
                { value: true, text: this.$t('userProfile.metric') },
                { value: false, text: this.$t('userProfile.imperial') }
              ]"
              v-model="user.metric"
              item-text="text"
              item-value="value"
            ></v-select>
            <v-select
              filled
              prepend-icon="mdi-palette"
              :label="$t('user.theme.title')"
              :items="[
                { value: true, text: this.$t('userProfile.dark') },
                { value: false, text: this.$t('userProfile.light') }
              ]"
              v-model="user.theme"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-card-text>
          <v-card-actions class="my-4">
            <v-btn
              rounded
              class="mx-auto"
              x-large
              color="primary"
              @click="update"
            >
              {{ $t("user.save") }}
            </v-btn>
          </v-card-actions>
        </base-material-card></v-col
      >
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import UserProfile from "../Index";
export default {
  pageTitle: "My Profile",
  data() {
    return {
      snackbar: false,
      form: [],
      showAvatarPicker: false
    };
  },
  components: {
    UserProfile,
    avatar: () => import("./Avatar")
  },
  computed: {
    ...mapState("auth", ["user"]),
    dateFixed() {
      if (this.user.dateCreated) {
        if (this.$root.$i18n.locale === "es") {
          return moment
            .unix(this.user.dateCreated.seconds)
            .locale("es")
            .format("MMMM D YYYY, h:mm:ss a");
        } else {
          return moment
            .unix(this.user.dateCreated.seconds)
            .format("MMMM D YYYY, h:mm:ss a");
        }
      } else {
        return null;
      }
    }
  },
  methods: {
    async update() {
      const loading = this.$vs.loading({
        background: "#730D0B",
        color: "rgb(255, 255, 255)",
        opacity: 1,
        type: "square"
      });
      let payload = {
        db: "users",
        doc: this.user.id,
        data: this.user
      };
      try {
        await this.$store.dispatch("updateDocument", payload);
        this.$i18n.locale = this.user.language;

        this.$vuetify.theme.dark = this.user.theme;
        loading.close();
        this.$dialog.notify.success(
          this.$t("userProfile.messages.updateSuccess"),
          {
            position: "top-right",
            timeout: 5000
          }
        );
      } catch (error) {
        loading.close();
        this.$router.push({ name: "Error" });
      }
    }
  }
};
</script>
